import { Navigate, Route, Routes as Switch } from "react-router-dom"
import { BrowserRouter } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { Toaster } from "react-hot-toast"
import Home from "../../pages/home/index"
import DeleteAccount from "../../pages/delete-account/index"
import { AdminRoutes } from "../../../features/admin"

// Criar instância do QueryClient
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            staleTime: 5 * 60 * 1000, // 5 minutos
        },
    },
})

function Routes() {
    return (
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <Switch>
                    {/* Rotas públicas */}
                    <Route path="/" element={<Home />} />
                    <Route path="/delete-account" element={<DeleteAccount />} />

                    {/* Rotas do Admin */}
                    <Route path="/admin/*" element={<AdminRoutes />} />

                    {/* Fallback */}
                    <Route path="*" element={<Navigate to="/" />} />
                </Switch>
            </BrowserRouter>

            {/* Toast notifications */}
            <Toaster
                position="top-right"
                toastOptions={{
                    duration: 4000,
                    style: {
                        background: '#363636',
                        color: '#fff',
                    },
                    success: {
                        style: {
                            background: '#10B981',
                        },
                    },
                    error: {
                        style: {
                            background: '#EF4444',
                        },
                    },
                }}
            />
        </QueryClientProvider>
    )
}

export default Routes
